// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"318":"5f752195","369":"5f752195"}[chunkId] + ".chunk.css";
};